import { Link } from 'react-router-dom';
import { Icon } from './Icon';

/** Small contextual "How it works" link. Opens the in-app How-to guide
 *  in a new tab, jumped to the section that covers the surface the user
 *  is currently on. Deliberately quiet visually — sits in a page header
 *  or tab bar next to the primary actions without competing with them.
 *
 *  Pass a `section` matching one of the anchor ids in HowToGuide.tsx
 *  (e.g. 'partnership-setup', 'outreach', 'placements'). */
export const HowItWorksLink = ({
  section,
  label = 'How it works',
}: {
  section: string;
  label?: string;
}) => (
  <Link
    to={`/how-to#${section}`}
    target="_blank"
    rel="noopener noreferrer"
    title="Open the How-to guide in a new tab"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      padding: '4px 10px',
      borderRadius: 999,
      fontSize: 11.5,
      color: 'var(--ink-3)',
      background: 'transparent',
      border: '1px solid var(--border)',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      lineHeight: 1.4,
    }}
    onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--ink)'; e.currentTarget.style.borderColor = 'var(--border-strong)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--ink-3)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
  >
    <Icon name="helpCircle" size={11} />
    {label}
  </Link>
);

export default HowItWorksLink;
